module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/CY-1c80218fb8942eecc988f5d94c3cb45e.png";